<template>
  <nav class="bottom-nav fixed bottom-0 flex items-center justify-center bg-gray-800 text-white h-[70px] z-10"
       ref="bottomNav">
    <BottomNavigationItem :title="$t('profile')" to="/profile">
      <UserIcon/>
    </BottomNavigationItem>

    <BottomNavigationItem :title="$t('restaurant')" to="/category/restaurant">
      <BookOpenIcon/>
    </BottomNavigationItem>

    <BottomNavigationItem class="active" :title="$t('home')" to="/">
      <HomeIcon/>
    </BottomNavigationItem>

    <BottomNavigationItem :title="$t('shop')" to="/category/shop">
      <TicketIcon/>
    </BottomNavigationItem>

    <BottomNavigationItem title="سبد خرید" :cart="true" @click="this.$cart.value = true">
      <span class="badge absolute -top-3 right-2 bg-red-500 px-2 py-1 rounded-full text-xs"
            v-if="cartCount">{{ cartCount }}</span>
      <ShoppingCartIcon/>
    </BottomNavigationItem>

    <div
        class="indicator absolute h-16 w-16 rounded-full bg-brand border-4 border-gray-100 transition-all top-[-50%]"></div>
  </nav>
</template>

<script>
import {BookOpenIcon, HomeIcon, ShoppingCartIcon, TicketIcon, UserIcon} from "@heroicons/vue/outline";
import BottomNavigationItem from "@/components/BottomNavigationItem";
import {mapGetters} from "vuex";

export default {
  name: "BottomNavigation",
  components: {BottomNavigationItem, HomeIcon, UserIcon, ShoppingCartIcon, BookOpenIcon, TicketIcon},
  computed: {
    ...mapGetters(['cartCount'])
  },
  watch: {
    '$route'() {
      let bottomNavItems = this.$refs.bottomNav.children
      for (let i = 0; i < bottomNavItems.length; i++) {
        bottomNavItems.item(i).classList.remove('active')
      }

      if (this.$route.path.startsWith('/profile')) {
        bottomNavItems.item(0).classList.add('active')
      } else if (this.$route.path.startsWith('/category/restaurant')) {
        bottomNavItems.item(1).classList.add('active')
      } else if (this.$route.path.startsWith('/category/shop')) {
        bottomNavItems.item(3).classList.add('active')
      } else if (this.$route.path.startsWith('/')) {
        bottomNavItems.item(2).classList.add('active')
      }
    }
  }
}
</script>

<style scoped>
.bottom-nav:before {
  content: '';
  height: 10px;
  width: 100vw;
  position: absolute;
  top: -10px;
  background-color: #f3f4f6;
}

.indicator:before {
  content: '';
  position: absolute;
  top: 56%;
  left: -18px;
  width: 20px;
  height: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0 -8px 0 0 #f3f4f6;
}

.indicator:after {
  content: '';
  position: absolute;
  top: 56%;
  right: -18.5px;
  width: 20px;
  height: 20px;
  border-top-left-radius: 20px;
  box-shadow: 0 -10px 0 0 #f3f4f6;
}
</style>